// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_mainTable__cxTFZ {
  width: 100%;
  overflow-x: auto;
  border: 1px solid #DCDFE1;
  border-radius: 0.2rem;
}
.table_mainTable__cxTFZ .table_badge__z-hrt {
  width: fit-content;
  padding: 0.2rem 0.75rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/components/UI/CustomTable/table.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AACF;AAEE;EACE,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAJ","sourcesContent":[".mainTable {\n  width: 100%;\n  overflow-x: auto;\n  border: 1px solid #DCDFE1;\n  border-radius: 0.2rem;\n\n\n  .badge {\n    width: fit-content;\n    padding: 0.2rem 0.75rem;\n    border-radius: 0.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainTable": `table_mainTable__cxTFZ`,
	"badge": `table_badge__z-hrt`
};
export default ___CSS_LOADER_EXPORT___;
